import request from '@/utils/request'

let DataApi = {
  /*用户接口*/
  getUser(data) {
    return request._post('/shop/data.user/lists', data);
  },
  /*获取用户操作接口*/
  getHandleUser(data) {
    return request._post('/shop/data.user/getHandleUser', data);
  },
  
  /*用户接口*/
  getStoreUser(data) {
    return request._post('/shop/store.clerk/getStoreUser', data)
  },
  /*配送员列表接口*/
  getDeliveryUser(data) {
    return request._post('/shop/plus.deliveryStaff.Index/getList', data)
  },
  getQrcode(data, errorback) {
    return request._post('/shop/data.qrcode/getImage', data, errorback);
  },
  getDeliveryList(data, errorback) {
    return request._post('/shop/data.product/deliveryList', data, errorback);
  },
  getExpressList(data, errorback) {
    return request._post('/shop/data.express/lists', data, errorback);
  },
  getBankList(data, errorback) {
    return request._post('/shop/data.bank/lists', data, errorback);
  },
  getOrder(data, errorback) {
    return request._post('/shop/data.order/getOrder', data, errorback);
  },
}
export default DataApi;



// WEBPACK FOOTER //
// ./src/api/data.js